import React from 'react'

import { DriverLink } from '@front/squirtle/elements'
import { TableCell } from '@mui/material'

const Driver = ({ row }) => {
  const driver = row?.assigned_transport?.driver
  return (
    <TableCell padding='none' sx={{ maxWidth: 150 }}>
      {!!driver
        ? <DriverLink
          record_id={driver}
          _typography={{ noWrap: true, width: '98%' }}
          _tooltipText={{ enable: true }}
        />
        : '-'}
    </TableCell >
  )
}

export default React.memo(Driver)
